import CardSystem from '../CardSystem';
import { ICardStateTaskData } from '../../../State/Card/ICardState';
import { RenderSystemEvent } from 'System/Render/RenderSystem';
import { AnimationClipTask } from 'Utility/Task/AnimationClipTask';
import { UseCanisterPreBooster } from '../../Animation/Clip/UseCanisterPreBooster';
import { UIEvent } from 'System/UI/BaseUISystem';

export default function UseCanisterPreBoosterAnimation(
    system: CardSystem,
    taskData: ICardStateTaskData,
): void {
    system.scene.emit(UIEvent.DISABLE_INTERACTIVITY, false);

    system.scene.emit(RenderSystemEvent.BRING_TO_FRONT, system.animator);
    const card = system.getCardByID(taskData.cards[0]);

    system.taskQueue.queue(
        new AnimationClipTask(
            new UseCanisterPreBooster(card, {
                system,
            })
        )
    );
}
